import { render } from "./IconCheck.vue?vue&type=template&id=0cec298a"
import script from "./IconCheck.vue?vue&type=script&lang=ts"
export * from "./IconCheck.vue?vue&type=script&lang=ts"
script.render = render

export default script